var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscriptionPage-detail"},[(_vm.showTips)?_c('div',{staticClass:"tips"},[_vm._v("当前二维码无效，请检查")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }